// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let PageViews = require("../../PageViews.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UseWindowSize = require("uikit/hooks/useWindowSize");
let RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql = require("../../../__generated__/RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.bs.js");

let convertVariables = RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.Internal.convertVariables;

let convertResponse = RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, RecordPropertyCreatedEvent_RecordPropertyCreatedEventV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let RecordPropertyCreatedEventV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useRecordEvent() {
  let isImpersonated = AuthSession.useIsImpersonated();
  let match = use();
  let mutate = match[0];
  let size = UseWindowSize.useWindowSize();
  return propertyId => {
    if (isImpersonated) {
      return;
    } else {
      mutate({
        input: {
          occurredAt: Scalars.DateTime.fromJsDate(new Date()),
          propertyId: propertyId,
          userAgent: PageViews.userAgent(),
          windowSize: {
            height: size.height,
            width: size.width
          }
        }
      }, undefined, undefined, undefined, undefined, undefined, undefined);
      return;
    }
  };
}

exports.RecordPropertyCreatedEventV5Mutation = RecordPropertyCreatedEventV5Mutation;
exports.useRecordEvent = useRecordEvent;
/* commitMutation Not a pure module */
